var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("animated-number", {
    attrs: { value: _vm.value, formatValue: _vm.formatToPrice, duration: 3000 }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }